import api from "../_api";

const actions = {
    voucherRequest: ({ commit, dispatch }, payload) => {
        let data = {
            voucher_number: payload.voucherNumber,
            voucher_pin: payload.voucherPin,
            akv: payload.akv,
        };

        return new Promise((resolve, reject) => {
            commit("COUPON_LOADING");

            api.voucher(data)
                .then(resp => {
                    commit("COUPON_SUCCESS", resp.data);
                    commit("STORE_COUPON");
                    commit("COUPON_MESSAGE");
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("COUPON_ERROR", errors);
                    commit("COUPON_MESSAGE", data);
                    reject(err.response);
                });
        });
    },
    removeVoucher: ({ commit }) => {
        commit("REMOVE_VOUCHER");
        commit("CLEAR_COUPON_ERRORS");
        commit("CLEAR_COUPON_MESSAGE");
    },
    removeVoucherError: ({ commit }) => {
        commit("REMOVE_VOUCHER");
    },
    clearCouponErrors: ({ commit }) => {
        commit("CLEAR_COUPON_ERRORS");
    },
    clearCouponMessage: ({ commit }) => {
        commit("CLEAR_COUPON_MESSAGE");
    },
    getVoucherTotal: ({ commit }, payload) => {
        commit("UPDATE_DISCOUNT_TOTAL", payload);
    },
};

export default actions;
